import { GeographicEntityListPage } from '@/components/geographic/GeographicEntityListPage'
import { geographicEntities } from '@/config/geographicEntities'

export default function AreaClustersPage() {
  return <GeographicEntityListPage config={geographicEntities.areaClusters} />
}
